/**
 * App Account routes
 */
import Cabinet from '../components/Account/Cabinet'
import Account from '../components/Account/Account'
import MyCompanies from '../components/Account/MyCompanies'
import Bill from '../components/Account/Bill'
import Colors from '../components/Account/Colors'
import Payment from '../components/Account/Payment'

const routes = [
  /*{
    path: '',
    name: 'Cabinet',
    component: Cabinet,
    meta: { noPostContext: true }
  },*/
  {
    path: '',
    name: 'Profile',
    component: Account,
    meta: { noPostContext: true }
  },
  {
    path: 'my-groups',
    name: 'MyGroups',
    component: MyCompanies,
    meta: { noPostContext: true }
  },
  {
    path: 'colors',
    name: 'Colors',
    component: Colors,
    meta: { noPostContext: true }
  },
  {
    path: 'payment',
    name: 'Payment',
    component: Payment,
    meta: { noPostContext: true }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/static/agreement.vue'),
    meta: { public: true, noPostContext: true }
  }
  /*{
    path: 'bill',
    name: 'Bill',
    component: Bill,
    meta: { noPostContext: true }
  }*/
]

export default routes



// WEBPACK FOOTER //
// ./src/apps/account/router/routes.js